export enum TypesOfDonationsEnum {
  Standard = 0,
  Tier = 1
}
